import { forwardRef, ReactNode, Ref } from 'react'
import { InputAdornment, TextField, TextFieldProps } from '@mui/material'
import { styled } from '@mui/system'
import { FieldError } from 'react-hook-form'

type LoginInputProps = {
  preIcon?: ReactNode
  error?: boolean
  cut?: 'top' | 'bottom' | 'none'
} & TextFieldProps

const bottom = {
  borderTopRightRadius: '0px',
  borderTopLeftRadius: '0px',
  borderBottomRightRadius: '10px',
  borderBottomLeftRadius: '10px',
}

const top = {
  borderTopRightRadius: '10px',
  borderTopLeftRadius: '10px',
  borderBottomRightRadius: '0px',
  borderBottomLeftRadius: '0px',
}

const StyledTextField = styled(TextField)<LoginInputProps>(
  ({ theme, cut, error }) => ({
    padding: '0px',
    backgroundColor: theme.palette.common.white,
    ...(cut === 'top' ? top : cut === 'bottom' ? bottom : undefined),
    height: '44px',
    outline: '0px',

    '& .MuiOutlinedInput-root': {
      height: '44px',
      fontSize: '14px',
      outline: '0px',

      '& fieldset': {
        borderBottom: cut === 'top' && !error ? 0 : '1px solid red',
        borderColor: theme.palette.grey[200],
        ...(cut === 'top' ? top : cut === 'bottom' ? bottom : undefined),
      },
      '&:hover fieldset': {
        borderColor: !!error ? 'red' : theme.palette.grey[300],
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.grey[300],
        borderWidth: 1,
      },
    },
  })
)

export const LoginInput = forwardRef(
  ({ preIcon: Icon, ...rest }: LoginInputProps, ref: Ref<HTMLDivElement>) => {
    return (
      <StyledTextField
        ref={ref}
        {...rest}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">{Icon}</InputAdornment>
            ),
          },
        }}
      />
    )
  }
)
